import { render, staticRenderFns } from "./StartForm15.vue?vue&type=template&id=000afccd&scoped=true"
import script from "./StartForm15.vue?vue&type=script&lang=ts"
export * from "./StartForm15.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000afccd",
  null
  
)

export default component.exports